import ActionCache from '@leverege/api-redux/lib/ActionCache.js';
import Util from "./Util.js";
const cache = new ActionCache();
const setCacheTime = cacheTime => {
  cache.ttl = cacheTime;
};
const getCacheTime = () => {
  return cache.ttl;
};
const canCache = new ActionCache();
const setCanCacheTime = cacheTime => {
  canCache.ttl = cacheTime;
};
const getCanCacheTime = () => {
  return canCache.ttl;
};
export default class FotaApi {
  constructor({
    relationship,
    actionCache = cache,
    canActionCache = canCache
  }) {
    this.relationship = relationship;
    // I fully expect no one to ever pass these in
    this.cache = actionCache;
    this.canCache = canActionCache;
  }
  getApi(api) {
    return api.system(this.relationship.options.systemId).srv('fota');
  }
  getAll(type, {
    maxRetrieved,
    pageSize,
    queryName
  } = {}) {
    return Util.getAll(type, {
      maxRetrieved,
      pageSize,
      api: this,
      queryName
    });
  }
  deviceType(idOrObj) {
    return Util.createCrudl('deviceType', idOrObj, this);
  }
  deviceGroup(idOrObj) {
    return Util.createCrudl('deviceGroup', idOrObj, this);
  }
  firmwareRelease(idOrObj) {
    return {
      ...Util.createCrudl('firmwareRelease', idOrObj, this),
      pause: Util.fwAction('pause', idOrObj, this),
      resume: Util.fwAction('resume', idOrObj, this),
      stop: Util.fwAction('stop', idOrObj, this),
      canPause: Util.fwCanAction('pause', idOrObj, this),
      canResume: Util.fwCanAction('resume', idOrObj, this),
      canStop: Util.fwCanAction('stop', idOrObj, this),
      releaseByImagineGroups: Util.createCrudl('firmwareReleaseByImagineGroups', idOrObj, this).create
    };
  }
  firmwareApplication(idOrObj) {
    return Util.createCrudl('firmwareApplication', idOrObj, this);
  }
  firmwareComponent(idOrObj) {
    return Util.createCrudl('firmwareComponent', idOrObj, this);
  }
  device(idOrObj) {
    return Util.createCrudl('device', idOrObj, this);
  }
}
FotaApi.setCacheTime = setCacheTime;
FotaApi.getCacheTime = getCacheTime;
FotaApi.setCanCacheTime = setCanCacheTime;
FotaApi.getCanCacheTime = getCanCacheTime;